/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesPlayGameType;
(function (FxIdDomainEntitiesPlayGameType) {
    FxIdDomainEntitiesPlayGameType[FxIdDomainEntitiesPlayGameType["Unity"] = 0] = "Unity";
    FxIdDomainEntitiesPlayGameType[FxIdDomainEntitiesPlayGameType["Iframe"] = 1] = "Iframe";
    FxIdDomainEntitiesPlayGameType[FxIdDomainEntitiesPlayGameType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesPlayGameType || (FxIdDomainEntitiesPlayGameType = {}));
export function instanceOfFxIdDomainEntitiesPlayGameType(value) {
    for (const key in FxIdDomainEntitiesPlayGameType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesPlayGameType, key)) {
            if (FxIdDomainEntitiesPlayGameType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesPlayGameTypeFromJSON(json) {
    return FxIdDomainEntitiesPlayGameTypeFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesPlayGameTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesPlayGameTypeToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesPlayGameTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesPlayGameType.js.map